import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import SnackbarContainer from '@softwaredev_cegeka/stix-notifier/dist/components/SnackbarContainer'
import Notifier from '@softwaredev_cegeka/stix-notifier/dist/components/Notifier'
import SwStatusIndicator from 'src/components/SwStatusIndicator'

// Routes
import Main from './routes/Main'
import withAuth from 'src/HOCs/withAuth'
import Unauthorized from './routes/Unauthorized'
import ErrorBoundary from 'src/components/ErrorBoundary'
import ServiceWorkerUpdater from 'src/components/ServiceWorkerUpdater'
import MfeLoader from 'src/components/MfeLoader'
import { useTranslation } from 'react-i18next'
import { pushGtmDataLayer } from 'src/utils/gtm'
import PushDrawer from './components/PushDrawer'
import { PushDrawerProvider } from './components/PushDrawer/pushDrawerContext'

function App() {
    const { i18n } = useTranslation()

    useEffect(() => {
        pushGtmDataLayer({
            event: 'languageInitial',
            language: i18n.language,
        })

        const handleLanguageChange = lng => {
            pushGtmDataLayer({
                event: 'languageChange',
                langauge: lng,
            })
        }

        i18n.on('languageChanged', handleLanguageChange)

        // Cleanup listener on unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange)
        }
    }, [i18n])

    const MainContent = withAuth(Main)

    return (
        <React.StrictMode>
            <Notifier>
                <ErrorBoundary>
                    <MfeLoader>
                        <Router>
                            <Switch>
                                <Route
                                    exact
                                    path={'/unauthorized'}
                                    component={Unauthorized}
                                />
                                <PushDrawerProvider>
                                    <PushDrawer>
                                        <MainContent />
                                    </PushDrawer>
                                </PushDrawerProvider>
                            </Switch>
                        </Router>
                    </MfeLoader>
                </ErrorBoundary>
                <SnackbarContainer
                    defaults={{
                        position: 'fixed',
                    }}
                />
                <ServiceWorkerUpdater pollInterval={60000} />
            </Notifier>
            {/* This is kinda hacky, but because it is cached by the service-worker and process.env.NODE_ENV is baked in at build-time there's no real alternative for detecting we're in dev. */}
            {window?.location?.host === 'localhost:8080' && (
                <SwStatusIndicator />
            )}
        </React.StrictMode>
    )
}

export default App
